import Marquee from "react-fast-marquee";

const WORDS = ["Grow", "Generate", "Grid-tie", "Freestanding Solar", "Solar Garden"];

export const EditorialMarquee = () => {
  return (
    <section
      className="relative bg-sg-bg py-16 sm:py-20 border-y border-sg-border/50 overflow-hidden"
      data-testid="marquee-section"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-6xl sm:text-8xl lg:text-9xl tracking-tight text-sg-fg/90 px-8">
              {w}
            </span>
            <span className="text-sg-primary text-4xl sm:text-6xl px-2">·</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};
